import React from "react";
import * as Cesium from 'cesium';
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { Grid, Button } from "@mui/material";
import { MapModalAnnotateStatus, AnnotationTypes } from "constant";
import { CheckCircleOutline, MultilineChart } from "@mui/icons-material";

const CustomButton = styled(Button)`
  width: 100%;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
  
  .MuiButton-label {
    color: white;
    font-size: 14px;
    text-transform: none;
    line-height: 19px;
    font-weight: 400;
    .MuiButton-startIcon {
      width: 20px;
    }
  }

  &.Mui-success {
    color: #15c67d !important;
    .MuiButton-label {
      color: #15c67d !important;
    }
  }
`;

const CustomButtonWithBorder = styled(CustomButton)`
  border-right: 1px solid gray !important;
  border-radius: 0 !important;
`;

const Wrapper = styled(Grid)`
  border-top: 1px solid gray;
  background: #2F2F2F;
  
  .FooterButtonContainer {
    button {
      font-size: 12px;
      color: white;
    }
    
    button.Mui-disabled {
      color: #a0a0a0 !important;
    }
  }
`;

const Bottom = (props) => {
  const { type, info, onChangeDimension, status, onSubmit } = props;
  const dispatch = useDispatch();

  const Profile3D = () => {
    dispatch({ type: 'TOGGLE_CHART', show: true })
    var entity = window.GlobalAnnotationEntities.entities.values.find(e => e.id == info.annotationId)
    var samplePositions = [];
    if (info.type == "Line") {
      var cart3Positions = entity.polyline.positions.getValue();
    } else if (info.type == "Area") {
      var cart3Positions = entity.polygon.hierarchy.getValue().positions;
    }
    var cartoPositions = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cart3Positions)
    for (var i = 0; i < cartoPositions.length - 1; i++) {
      var start = cartoPositions[i];
      var end = cartoPositions[i + 1];

      var length = Cesium.Cartesian3.distance(cart3Positions[i], cart3Positions[i + 1]) * 4; //for every 0.25m
      for (var j = 0; j < length; j++) {
        var lon = Cesium.Math.lerp(start.longitude, end.longitude, j / length);
        var lat = Cesium.Math.lerp(start.latitude, end.latitude, j / length);
        var position = new Cesium.Cartographic(lon, lat);
        position.height = getHeight(window.MAIN_CESIUM_VIEWER, Cesium.Ellipsoid.WGS84.cartographicToCartesian(position))
        if (position.height != undefined) {
          samplePositions.push(position);
        }
      }
    }

    dispatch({ type: 'SET_CHART_POINTS', points: samplePositions })
  }

  function getHeight(viewer, cartesian) {
    if (viewer.scene.clampToHeightSupported) {
      const pickedResult = viewer.scene.clampToHeight(cartesian, viewer.entities._entities._array);
      if (pickedResult) {
        return Cesium.Ellipsoid.WGS84.cartesianToCartographic(pickedResult).height;
      }
    }
    
    return viewer.scene.globe.getHeight(Cesium.Ellipsoid.WGS84.cartesianToCartographic(cartesian))
  }

  if (!AnnotationTypes[type]) return <></>;

  return (
    <Wrapper container>
      <Grid size={6} className='FooterButtonContainer'>
        <CustomButtonWithBorder startIcon={<CheckCircleOutline />} disabled={!status || !status.length} onClick={() => { onSubmit(window.actualAnnotationId) }} className={status === MapModalAnnotateStatus.Success ? "Mui-success" : ""}>
          { status === MapModalAnnotateStatus.Success ? "Save Success" : "Save Changes" }
        </CustomButtonWithBorder>
      </Grid>
      <Grid size={6} className='FooterButtonContainer'>
        <CustomButton startIcon={<MultilineChart />} disabled={false} onClick={Profile3D}>
          3D Profile
        </CustomButton>
      </Grid>
    </Wrapper>
  );
};

export default Bottom;